import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import {
  Container,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel
} from '@material-ui/core';

import './styles.css';

const AreaDeFuncionamento = (props) => {

  const fonteAbastecimentoDeAguaOptions = [
    'Rede Pública', 'Poço', 'Cisterna', 'Outros'
  ];
  const [data, setData] = useState(props.data);
  const latestData = useRef(data);
  const [validacao, setValidacao] = useState({
    areaConstruida: { error: false, required: true, minValue: 0, maxValue: 250, message: '' },
    areaLivre: { error: false, required: true, minValue: 0, maxValue: 250, soma: '', message: '' },
    areaTotal: { error: false, required: true, minValue: 0, maxValue: 250, soma: 250, message: '' },
    funcionarios: { error: false, required: true, message: '' },
    inicioExpediente: { error: false, required: true, message: '' },
    fimExpediente: { error: false, required: true, message: '' },
  })

  const requiredFieldValidation = (name, value) => {
    const { length } = value
    let field = validacao[name]
    if (length === 0) {
      field.error = true
      field.message = `${field.message}Este campo é obrigatório. `
    }
    setValidacao({ ...validacao, [name]: field })
  }

  const minValueValidation = (name, value) => {
    let field = validacao[name]
    if (value < field.minValue) {
      field.error = true
      field.message = `${field.message}Este campo precisa ser maior ou igual à ${field.minValue}. `
    }
    setValidacao({ ...validacao, [name]: field })
  };

  const maxValueValidation = (name, value) => {
    // const {length} = value
    let field = validacao[name]
    if (value > field.maxValue) {
      field.error = true
      field.message = `${field.message}Este campo precisa ser menor ou igual à ${field.maxValue}.  `
    }
    setValidacao({ ...validacao, [name]: field })
  };

  const handleInputValidation = (event) => {
    const { name, value } = event.target;
    validacao[name].message = ''
    validacao[name].error = false
    if (validacao[name].hasOwnProperty('required') && validacao[name].required === true) {
      requiredFieldValidation(name, value);
    }
    if (validacao[name].hasOwnProperty('minValue')) {
      minValueValidation(name, value);
    }
    if (validacao[name].hasOwnProperty('maxValue')) {
      maxValueValidation(name, value);
    }
  }

  const handleInputText = ({ target: { name, value } }) => {

    setData({ ...data, [name]: value });

  };

  const handleDataChanged = () => {
    const { dispatch } = props;
    dispatch({
      type: 'ADD_TO_FORM',
      data: {
        AreaDeFuncionamento: latestData.current
      }
    });
  }

  useEffect(() => {
    latestData.current = data;
  }, [data]);

  useEffect(() => {
    return () => handleDataChanged()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const areaTotal = () => {
    let areaConstruida = isNaN(data.areaConstruida) ? 0 : parseFloat(data.areaConstruida);
    let areaLivre = isNaN(data.areaLivre) ? 0 : parseFloat(data.areaLivre);
    return areaConstruida + areaLivre;
  }

  return (
    <Container maxWidth="lg" >
      <h1 className="mobile-title" style={{ display: 'none' }}>2. Área de Funcionamento</h1>
      <div className="form-group">
        <div className="soma-area">
          <TextField
            autoFocus
            label="Área Construída (m²)"
            name="areaConstruida"
            required
            inputProps={{ minLength: 1 }}
            error={validacao.areaConstruida.error}
            helperText={(validacao.areaConstruida.error === true) ? validacao.areaConstruida.message : ''}
            onBlur={handleInputValidation}
            onChange={(e) => handleInputText(e)}
            value={data.areaConstruida || ''}
            InputProps={{ inputProps: { min: 0, max: 250, step:"0.05" }
          }}
            variant="outlined"
            type='number'

          />
        </div>
        <div className="soma-area">
          <TextField
            label="Área Livre (m²)"
            name="areaLivre"
            value={data.areaLivre||''}
            InputProps={{ inputProps: { min: 0, max: 250,step:"0.05" } }}
            onChange={(e) => handleInputText(e)}
            inputProps={{ minLength: 1,step:"0.05" }}
            required
            error={validacao.areaLivre.error}
            helperText={(validacao.areaLivre.error === true) ? validacao.areaLivre.message : ''}
            onBlur={handleInputValidation}
            variant="outlined"
            type='number'
          />
        </div>
        <div className="soma-area" >
          <TextField
            label="Área Total (m²)"
            name="areaTotal"
            disabled={true}
            error={(data.areaTotal > 250) ? true : false}
            helperText={(data.areaTotal > 250) ? 'Este campo nao pode ser maior que 250' : ''}
            // value={areaTotal()}
            inputProps={{ step:"0.01" }}
            value={data.areaTotal = areaTotal()}
            variant="outlined"
          />
        </div>
        <TextField
          label="Número de funcionários"
          name="funcionarios"
          defaultValue={data.funcionarios}
          inputProps={{ minLength: 1 }}
          required
          error={validacao.funcionarios.error}
          helperText={(validacao.funcionarios.error === true) ? validacao.funcionarios.message : ''}
          onBlur={handleInputValidation}
          onChange={handleInputText}
          variant="outlined"
        />
      </div>
      <div className="form-group">
        <TextField
          className="time"
          label="Início"
          name="inicioExpediente"
          required
          error={validacao.inicioExpediente.error}
          helperText={(validacao.inicioExpediente.error === true) ? validacao.inicioExpediente.message : ''}
          onBlur={handleInputValidation}
          type="time"
          defaultValue={data.inicioExpediente}
          onChange={handleInputText}
          variant="outlined"
        />
        <TextField
          className="time"
          label="Fim"
          name="fimExpediente"
          required
          error={validacao.fimExpediente.error}
          helperText={(validacao.fimExpediente.error === true) ? validacao.fimExpediente.message : ''}
          onBlur={handleInputValidation}
          type="time"
          defaultValue={data.fimExpediente}
          onChange={handleInputText}
          variant="outlined"
        />
      </div>
      <div className="form-group">
        <div className="radio" >
          <FormControl component="fieldset">
            <FormLabel component="legend">Fonte de Abastecimento de Água</FormLabel>
            <RadioGroup aria-label="gender"
              name="fonteAbastecimentoDeAgua"
              value={data.fonteAbastecimentoDeAgua || ''}
              onChange={handleInputText}

            >
              {fonteAbastecimentoDeAguaOptions.map(option => (
                <FormControlLabel key={option} type="radio" value={option} control={<Radio />} label={option} />
              ))}
            </RadioGroup>
          </FormControl>
          <div className="borda-outorga">
            <span className="outorga"
              style={data.fonteAbastecimentoDeAgua === 'Poço' ? { display: "block" } : { display: "none" }}
            >
              É necessário apresentar documento de outorga!
            </span>
          </div>
          <div className="outros-radios">
            <input type="text"
              id="outrosRadio"
              placeholder="Especificar fonte"
              name="fonteAbastecimentoDeAguaOutro"
              defaultValue={data.fonteAbastecimentoDeAguaOutro}
              onChange={handleInputText}
              style={data.fonteAbastecimentoDeAgua === 'Outros' ? { display: "block" } : { display: "none" }}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default connect(state => ({
  data: state.form.AreaDeFuncionamento,
}))(AreaDeFuncionamento);
